import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs/internal/Observable';
import { AddressPaginatedResponse, AddressResponse, CreatedAddressResponse } from '../domain/address-book.model';
import { AddressBookRepository } from './address-book.repository';
import { AddressDto } from './dto/address-book.dto';

@Injectable()
export class AddressBookApiService implements AddressBookRepository {
    private _http = inject(HttpClient);

    createAddress(address: AddressDto): Observable<CreatedAddressResponse> {
        return this._http.post<CreatedAddressResponse>(`${environment.url}${MICROSERVICES.address_book}/user-addresses`, address);
    }

    deleteAddress(addressId: string): Observable<void> {
        return this._http.delete<void>(`${environment.url}${MICROSERVICES.address_book}/user-addresses/${addressId}`);
    }
    getAddress(addressId: string): Observable<AddressResponse> {
        return this._http.get<AddressResponse>(`${environment.url}${MICROSERVICES.address_book}/user-addresses/${addressId}`);
    }
    getAddresses(page = 1, pageSize = 30): Observable<AddressPaginatedResponse> {
        const params = new HttpParams().set('page', page).set('size', pageSize);
        const options = {
            params,
        };
        return this._http.get<AddressPaginatedResponse>(`${environment.url}${MICROSERVICES.address_book}/user-addresses`, options);
    }
    updateAddress(addressId: string, address: AddressDto): Observable<void> {
        return this._http.patch<void>(`${environment.url}${MICROSERVICES.address_book}/user-addresses/${addressId}`, address);
    }
}
